<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row col-">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <calendario 
              label="Referência" 
              class="col-md-2" 
              inputText="Mês" 
              tipoData="mes" 
              formato="MM/YYYY" 
              :validado="state('referencia')" 
              inputInvalid="campo obrigatório"
              :disabledData="(date) => date >= new Date()" 
              v-on:emitindoMes="atribuiMes"
            />
            <b-form-group
              label="Contrato Serviço"
              invalid-feedback="campo obrigatório"
              class="col-md-3"
              :state="state('contrato')">
              <multiselect 
                v-model="dados.contrato" 
                placeholder="Selecione"
                :show-labels="false"
                :options="objetoContratoServico" 
                :custom-label="({ contrato, sq_contrato }) => `${contrato} - [${sq_contrato}]`"
                :allow-empty="false"
              />
            </b-form-group>
            <b-form-group
              label="Categoria"
              invalid-feedback="campo obrigatório"
              class="col-md-2"
              :state="state('tipo')">
                <multiselect 
                  v-model="dados.tipo" 
                  :options="objetoTipoDocumento" 
                  :show-labels="false" 
                  placeholder="Selecione"
                  @input="mudaModelo"
                  :allow-empty="false"/>
            </b-form-group>
            <b-form-group
              label="Modelo Documento"
              class="col-md-2">
                <multiselect 
                  v-model="dados.modelo"
                  placeholder="Selecione"
                  :show-labels="false"
                  :options="tempObjetoModeloDocumento"
                  @input="mudaEstilo"
                  label="name"
                  :allow-empty="false"/>  
            </b-form-group>
  
            <b-form-group
              label="Tipo"
              class="col-md-3">
              <multiselect 
                v-model="dados.estilo"
                placeholder="Selecione"
                :show-labels="false"
                :options="tempObjetoEstilo"
                label="ds_estilo"/>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              label="Situação"
              class="col-md-2">
              <multiselect 
                v-model="dados.situacao"
                placeholder="Selecione"
                :show-labels="false"
                :options="objetoSituacaoDocumento"
                track-by="value"
                label="name"
              />
            </b-form-group>
            <div class="col-md-10 text-end mt-4">
              <b-button variant="primary" @click="carregaLista()" >
                <i class="mdi mdi-filter-outline font-size-16 align-middle me-2"></i>
                Filtrar
              </b-button>
            </div>
          </div>
          
  
          <div class="mb-2 mt-2 col-12 d-flex justify-content-end">
            <b-form-checkbox-group
              v-model="selected"
              :options="options"
              plain
            ></b-form-checkbox-group>
          </div>
  
          <div class="row mb-2 mt-2">
            <div class="mt-2 col-12 d-flex justify-content-end ">
              <label class="d-inline-flex align-items-center">
                <b-form-input
                  v-model="pesquisa"
                  type="search"
                  placeholder="Pesquisar..."
                  class="form-control form-control-sm ms-2"
                ></b-form-input>
              </label>
            </div>
          </div>
  
          <div class="mt-2 col-auto" v-if="loadingDownload">
            <b-alert show :variant="variant">{{ alertText }}</b-alert>
          </div>
  
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              responsive="sm"
              :items="documentos"
              :fields="campos"
              :filter="pesquisa"
              :per-page="perPage"
              :current-page="currentPage"
              foot-clone
            >
              <template v-slot:cell(actions)="data">
                <div class="button-items" v-if="!loadingDownload">
                  <b-button
                    class="mr-3"
                    variant="primary"
                    @click="downloadRelatorio(data.item)"
                    v-b-tooltip.hover
                    title="Download"
                  >
                    <i class="mdi mdi-file-download d-block font-size-11"></i>
                  </b-button>
                </div>
                <div class="d-flex justify-content-center" v-if="loadingDownload">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                    v-b-tooltip.hover
                    title="Aguarde"
                  ></b-spinner>
                </div>
              </template>
              <template #foot(vl_debito)="">
                {{$tools.converteReal(totalDebito)}}
              </template>
              <template #foot(vl_credito)="">
                {{$tools.converteReal(totalCredito)}}
              </template>
              <template #foot(vl_liquido)="">
                {{$tools.converteReal(totalLiquido)}}
              </template>
              <template #foot()="">
                <h6></h6>
              </template>
            </b-table>
            <div class="d-flex justify-content-center" v-if="loading">
              <b-spinner
                class="m-2"
                variant="primary"
                role="status"
              ></b-spinner>
            </div>
  
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
  
            <div class="d-grid gap-2 d-md-flex justify-content-md-start">
              <router-link to="/tomadora/compliance">
                <button class="btn btn-light" type="button">Voltar</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import PageHeader from "@/components/page-header";
  import calendario from "@/components/formulario/data-input";
  import Multiselect from 'vue-multiselect'
  import { required } from "vuelidate/lib/validators";
  
  export default {
    components: { calendario, PageHeader, Multiselect },
    data(){
      return {
        title: "Documentos Faturados",
        noResult: 'Nenhum resutado encontrado!',
        noOptions: 'Nenhuma opção localizada!',
        variant: "warning",
        alertText: "Esse processo pode ser demorado, por favor aguarde!",
        pesquisa: null,
        loading: false,
        loadingDownload: false,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        tempObjetoModeloDocumento: [],
        tempObjetoEstilo: [],
        filterOn: [],
        documentos: [],
        invalidData: null,
        submit: null,
        totalDebito:0,
        totalCredito:0,
        totalLiquido:0,
        optionsDownload: false,
        selected: [],
        options: [],
        dados: {
          referencia: null,
          contrato: "0",
          tipo: "",
          modelo: "",
          estilo: "",
          situacao: ""
        },
        objetoContratoServico: [],
        objetoTipoDocumento: ['NDC', 'NFS-e'],
        objetoEstiloNdc: [],
        objetoEstiloNf: [],
        objetoModeloDocumento: [
          { name: 'Nota', value: '0', tipo: "NFS-e" },
          { name: 'NDC (Geral)', value: '0', tipo:"NDC"},
          { name: 'NDC - RDV', value: '1', tipo:"NDC", estiloReferencia:"RDV" },
          { name: 'NDC - Frota', value: '2', tipo:"NDC", estiloReferencia:"FROTA"},
          { name: 'NDC - Diversos', value: '3', tipo:"NDC", estiloReferencia:"DESPESAS"},
        ],
        objetoSituacaoDocumento: [
          { name: 'Aberto', value: 'a' },
          { name: 'Fechado', value: 'f' },
          { name: 'Ambos', value: '0' },
        ],
        campos: [
          {
            key: "nr_documento",
            label: "N° Doc",
            sortable: true,
          },
          {
            key: "emissao",
            label: "Emissão",
            formatter: (value) => {
              return this.formataData(value)
            },
            sortable: true,
          },
          {
            key: "vencimento",
            label: "Vencimento",
            formatter: (value) => {
              return this.formataData(value)
            },
            sortable: true,
          },
          {
            key: "centro_custo",
            label: "Centro de Custo",
            sortable: true,
          },
          {
            key: "estilo",
            label: "Estilo",
            sortable: true,
          },
          {
            key: "vl_debito",
            label: "Débitos",
            formatter: (value) => {
              return this.formataParaReais(value)
            },
            sortable: true,
          },
          {
            key: "vl_credito",
            label: "Créditos",
            formatter: (value) => {
              return this.formataParaReais(value)
            },
            sortable: true,
          },
          {
            key: "vl_liquido",
            label: "Líquido",
            formatter: (value) => {
              return this.formataParaReais(value)
            },
            sortable: true,
          },
          {
            key: "vl_saldo",
            label: "Saldo",
            formatter: (value) => {
              return this.formataParaReais(value)
            },
            sortable: true,
          },
          {
            key: "actions",
            label: "Ações",
          },
        ],
        items: [
          {
            text: "Compliance",
            href: "tomadora/compliance",
            active: false,
          },
          {
            text: "Faturados",
          },
        ]
      }
    },
  
    created() {
      this.$http.get("api/compliance")
      .then((response) => {
        this.objetoContratoServico = response.data.contratos;
        this.dados.contrato = this.objetoContratoServico[0];
        this.objetoEstiloNdc = response.data.estilosNdc;
        this.objetoEstiloNf = response.data.estilosNf;
      }).catch((err) => {
        console.log(err);
      });
    },
  
    computed: {
      rows() {
        return this.documentos.length;
      },
    },
  
    validations: {
      dados: {
        contrato: {
          required
        },
        tipo: {
          required
        },
        referencia:{
          required
        }
      }
    },
  
    methods: {
      state(param){
        if(this.submit){
          return !this.$v.dados[param].$invalid
        }else{
          return null
        }
      },
      mudaModelo(){
        this.configDownload();
        this.dados.modelo = ""
        this.dados.estilo = ""
        this.tempObjetoEstilo = []
        const exemplo = this.objetoModeloDocumento
        this.tempObjetoModeloDocumento = exemplo.filter(modelo => (modelo.tipo === this.dados.tipo))
      },
      mudaEstilo(){
        var exemplo = []
        if(this.dados.tipo === 'NDC'){
          this.tempObjetoEstilo = this.objetoEstiloNdc
          if(this.dados.modelo.value > 0){
            exemplo = this.objetoEstiloNdc
            this.tempObjetoEstilo = exemplo.filter((modelo) => {
              if(!modelo.ds_estilo.indexOf(this.dados.modelo.estiloReferencia)){
                return modelo
              }
            })
          }
        } else {
          this.tempObjetoEstilo = this.objetoEstiloNf
        }
      },
      atribuiMes(mes){
        this.dados.referencia = mes
      },
      carregaLista() {
        this.documentos = [];
        this.totalCredito = 0;
        this.totalDebito = 0;
        this.totalLiquido = 0;
        this.submit = true;
        this.$v.$touch()
        if(this.$v.$invalid) {
          return
        }
        if(this.dados.tipo == "NDC"){
          this.campos[5].label = "Débitos"
          this.campos[6].label = "Créditos"
        }else{
          this.campos[5].label = "Bruto";
          this.campos[6].label = "Tributos";
        }
        this.loading = true;
        var dataReformatada = this.dados.referencia.replace(/[/]/g, "-").split('-').reverse().join('-');
        let modelo = this.dados.modelo.value ? this.dados.modelo.value : "0";
        let estilo = "0";
        if(this.dados.estilo){
          estilo = this.dados.estilo.sq_estilo ? this.dados.estilo.sq_estilo : "0";
        }
        let situacao = this.dados.situacao.value ? this.dados.situacao.value : "0";
        let objetoDeEnvio = "api/compliance/"
                        + dataReformatada  + "/"
                        + this.dados.contrato.sq_contrato  + "/"
                        + this.dados.tipo  + "/"
                        + modelo + "/"
                        + estilo + "/" 
                        + situacao;
        this.$http.get(objetoDeEnvio)
        .then((response) => {
          this.documentos = response.data;
          this.calculoTotal();
          this.loading = false;
        })
        .catch((err) => {
          this.variant = "danger"
          this.alertText = err
        });
      },
      calculoTotal(){
        this.documentos.forEach((el) => {
          this.totalCredito += parseFloat(el.vl_credito);
          this.totalDebito += parseFloat(el.vl_debito);
          this.totalLiquido += parseFloat(el.vl_liquido);
        });
      },
      formataData(value){
          var dataFormatada = value.replace(/-/g, "/").substr(-20, 10).split('/').reverse().join('/');
          return dataFormatada
      },
      formataParaReais(value){
        var stringParaFloat = parseFloat(value)
        var valorFormatado = stringParaFloat.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
        return valorFormatado
      },
      downloadRelatorio(value){
        this.alertText = "Esse processo pode ser demorado, por favor aguarde!";
        this.variant = "warning"
        this.loadingDownload = true;
        console.log('Value', value);
        let mesReferencia = "01-" + value.mes_referencia.replace(/[/]/g, "-")
        let emissao = value.emissao.split(' ')[0].split('-').reverse().join('-');
        if(this.selected.includes('xml')){
          this.downloadXml(value);
        }
        if(value.id_boleto){
          this.downloadBoleto(value.id_boleto);
        }
        this.$http.post("api/compliance/relatorio",
        { cd_matriz:value.cd_matriz,
          sq_estilo:value.sq_estilo,
          sq_contrato:value.sq_contrato,
          va_referencia:mesReferencia,
          va_emissao:emissao,
          sq_controle:value.sq_controle,
          tp_ccusto:value.tp_ccusto,
          tp_modelo_documento:value.tp_modelo_documento,
          modelo_documento:value.modelo_documento,
          tipo:this.selected.join('-'),
          nota:{
            nr_rps:value.nr_rps,
            sr_nfisc:value.sr_nfisc,
            tp_especie:value.tp_especie,
          }
        },{ responseType: 'blob' })
        .then((response) => {
          var blob = new Blob([response.data], {
            type: 'application/pdf'
          });
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          this.loadingDownload = false;
        })
        .catch((err) => {
          console.log(err.response);
          this.variant = "danger"
          this.alertText = "Erro ao baixar relatório"
          this.loadingDownload = false;
        });
        
      },
      downloadXml(value){
        let objetoDeEnvio = "api/compliance/downloadXml/"
                            + value.nr_documento + "/"
                            + value.emissao;
        this.$http.get(objetoDeEnvio,{ responseType: 'blob' })
        .then((response) => {
          var blob = new Blob([response.data]);
          var url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "NFSe"+value.nr_documento+".zip");
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.variant = "danger"
          this.alertText = "Erro no arquivo .XML"
        });
      },
      downloadBoleto(idBoleto){
        let objetoDeEnvio = "api/compliance/downloadBoleto/"
                            + idBoleto;
        this.$http.get(objetoDeEnvio,{ responseType: 'blob' })
        .then((response) => {
          var blob = new Blob([response.data]);
          var url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "boleto_"+idBoleto+".pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.variant = "danger"
          this.alertText = "Erro no arquivo de boleto"
        });
      },
      configDownload(){
        this.options = []
        this.optionsDownload = !this.optionsDownload
        if(this.dados.tipo == "NDC"){
          this.selected = ['simples', 'completa'];
          this.options =  [
            { text: 'NDC', value: 'simples', disabled: true},
            { text: 'Comprovantes', value: 'completa'}
          ];
        }
        else{
          this.selected = ['nota'];
          this.options =  [
            { text: 'NFS-e', value: 'nota', disabled: true},
            { text: 'Espelho Faturamento', value: 'espelho'},
            { text: 'Arquivo .XML', value: 'xml'}
          ];
        }
      }
    }
  }
  </script>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  
  <style>
  
  .is-valid .multiselect__tags {
    border-color: #34c38f !important;
  }
  .is-invalid .multiselect__tags {
    border-color: #f46a6a !important;
  }
  
  .alinharTotal{
    text-align-last: right;
  }
  </style>
  